import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommunicationService } from './communication.service';
import { NudgeService } from './nudge.service';
import { GeminiSessionService } from './gemini-session.service';

@Injectable({
  providedIn: 'root'
})
export class ProductCallbackService {
  private capfinURL:string="https://www.capfin.co.za/apply-now/application-details?a=CF000126";

  constructor(
    private communicationService: CommunicationService,
    private nudgeService: NudgeService,
    private geminiSessionService: GeminiSessionService
  ) { }

  // ----- Sanlam Personal Loan (SPL) -----
  sanlamCallback(campaignSource: number): Observable<any> {
    return this.userCallback(campaignSource);
  }
  sanlamLead(): Observable<any> {
    return this.communicationService.transferLead();
  }

  // ----- Capfin -----
  capfinCallback(): void {
    this.geminiSessionService.handleExternalNavigation(this.capfinURL);
  }

  // ----- Debt Consolidation (DC) -----
  debtConsolidationCallback(campaignSource: number): Observable<any> {
    return this.userCallback(campaignSource);
  }

  // ----- Omni -----
  omniCallback(campaignSource: string, webSource: string): Observable<{ statusCode: number; returnUrl: string }> {
    const param = {
      CampaignSource: campaignSource,
      Referrer: 'JustMoney',
      WebSource: webSource,
      SessionId: sessionStorage.getItem('sessionId')
    };
    return this.communicationService.OmniLeadCreate(param).pipe(
      map((data: any) => ({ statusCode: data?.statusCode, returnUrl: data?.returnUrl }))
    );
  }

  // ----- Shared / generic -----
  userCallback(campaignSource: number): Observable<any> {
    const payload = {
      CampaignSourceType: campaignSource,
      WebSource: campaignSource === 32 ? '3' : 0,
      Referrer: campaignSource === 32 ? 'JustMoney' : null,
    };
    return this.communicationService.userCallbackSource(payload);
  }

  engageNudge(productType: string): Observable<any> {
    return this.nudgeService.upsertNudgeDate({ Action: 1, ProductType: productType });
  }

  dismissNudge(productType: string): Observable<any> | null {
    const alreadyNudged = sessionStorage.getItem('IsOfferNudged') === 'true';
    if (alreadyNudged) {
      return null;
    }
    return this.nudgeService.upsertNudgeDate({ Action: 0, ProductType: productType });
  }
}
